/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Ticketpageentrylabel3Inputs */

const en_ticketpageentrylabel3 = /** @type {(inputs: Ticketpageentrylabel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} of ${i?.total} checked in`)
};

const de_ticketpageentrylabel3 = /** @type {(inputs: Ticketpageentrylabel3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} von ${i?.total} eingecheckt`)
};

/**
* | output |
* | --- |
* | "{done} of {total} checked in" |
*
* @param {Ticketpageentrylabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageentrylabel3 = /** @type {((inputs: Ticketpageentrylabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageentrylabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageentrylabel3(inputs)
	return de_ticketpageentrylabel3(inputs)
});
export { ticketpageentrylabel3 as "ticketPageEntryLabel" }